/**
 * Jump a reversed message list to its newest message.
 *
 * A `flex-col-reverse` scrollport puts its scroll origin at the bottom: `scrollTop` runs
 * from `-(scrollHeight - clientHeight)` at the oldest message to `0` at the newest. So any
 * positive target clamps to `0` — the bottom — which is why the number is a large one and
 * never has to be measured. The same convention `ChannelScrollToBottom` reads when it
 * watches for a NEGATIVE threshold. Shared by that button and by the own-send handler, so
 * the magic number lives in one place.
 */
export function scrollChannelToBottom(
  container: HTMLElement | null,
  behavior: ScrollBehavior = "smooth",
) {
  container?.scrollTo({ top: 9999, behavior });
}
